const VALIDATION_MODE = {
  STRICT:  'strict',
  LENIENT: 'lenient',
};

const VALIDATION_MODE_ALL = _.values(VALIDATION_MODE);

export { VALIDATION_MODE, VALIDATION_MODE_ALL };

export default VALIDATION_MODE;
